// import React, { createContext, useContext, useEffect, useState } from "react";
// import { jwtDecode } from "jwt-decode";
// import { useNavigate, useLocation } from "react-router-dom";
//
// const AuthContext = createContext();
//
// export const AuthProvider = ({ children }) => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [user, setUser] = useState(null);
//     const [token, setToken] = useState(null);
//     const [loading, setLoading] = useState(true);
//
//     // UYGULAMA AÇILIŞINDA KULLANICI SET ET
//     useEffect(() => {
//         const t = localStorage.getItem("token");
//         const u = localStorage.getItem("user");
//
//         if (t && u) {
//             try {
//                 // token bozuksa uygulamayı çöp state’le başlatmayalım
//                 jwtDecode(t);
//                 setUser(JSON.parse(u));
//                 setToken(t);
//             } catch (e) {
//                 // console.warn("❌ Geçersiz token, temizleniyor");
//                 localStorage.removeItem("token");
//                 localStorage.removeItem("refreshToken");
//                 localStorage.removeItem("user");
//             }
//         }
//         setLoading(false);
//     }, []);
//
//     // (BIRAK) ACCESS TOKEN CHECK — sadece log atıyor, logout etmiyor
//     useEffect(() => {
//         const t = localStorage.getItem("token");
//         if (!t) return;
//
//         try {
//             const d = jwtDecode(t);
//             if (d.exp * 1000 < Date.now()) {
//                 // console.log("⚠ ACCESS TOKEN EXPIRED ama logout yok! Interceptor halledecek.");
//             }
//         } catch {
//             // console.log("⚠ Token decode edilemedi, interceptor logout eder.");
//         }
//     }, [location.pathname]);
//
//     // 🔥 YENİ: HER ROUTE DEĞİŞİMİNDE REFRESH TOKEN GEÇERLİ Mİ KONTROL ET
//     useEffect(() => {
//         const refresh = localStorage.getItem("refreshToken");
//         if (!refresh) return; // guest ise takılabilir
//
//         try {
//             const decoded = jwtDecode(refresh);
//             const now = Date.now();
//
//             if (decoded.exp * 1000 < now) {
//                 // console.log("⛔ REFRESH TOKEN EXPIRED → GLOBAL LOGOUT");
//                 logout("Session expired. Please login again!");
//             }
//         } catch (e) {
//             // console.log("⛔ REFRESH TOKEN DECODE EDİLEMEDİ → GLOBAL LOGOUT");
//             logout("Session invalid. Please login again!");
//         }
//     }, [location.pathname]); // 👈 her sayfa değişiminde çalışır
//
//     const login = (u, access, refresh, cartGuidFromServer) => {
//         localStorage.setItem("user", JSON.stringify(u));
//         localStorage.setItem("token", access);
//         localStorage.setItem("refreshToken", refresh);
//
//         if (cartGuidFromServer) {
//             localStorage.setItem("cart_guid", cartGuidFromServer);
//         }
//
//         setUser(u);
//         setToken(access);
//
//         setTimeout(() => {
//             const ctx = window.APP_CART_CONTEXT;
//             ctx?.reloadCart();  // 👈 SEPET YÜKLENİR
//         }, 50);
//
//         navigate("/");
//     };
//
//     const logout = (msg = null) => {
//         if (msg) localStorage.setItem("logoutMessage", msg);
//
//         localStorage.removeItem("token");
//         localStorage.removeItem("refreshToken");
//         localStorage.removeItem("user");
//         localStorage.removeItem("cart_guid");
//
//
//         const newGuid = crypto.randomUUID();
//         localStorage.setItem("cart_guid", newGuid);
//         // console.log("🛒 Yeni Guest GUID oluşturuldu:", newGuid);
//
//
//
//         setUser(null);
//         setToken(null);
//
//         requestAnimationFrame(() => {
//             const ctx = window.APP_CART_CONTEXT;
//             ctx?.setCartProducts([]); // 👈 sepet UI sıfırlanır
//         });
//
//         navigate("/", { replace: true });
//         openLoginModal();
//     };
//
//     const openLoginModal = () => {
//         setTimeout(() => {
//             const el = document.getElementById("login");
//             if (el && window.bootstrap?.Offcanvas) {
//                 let instance = window.bootstrap.Offcanvas.getInstance(el);
//
//                 if (!instance) {
//                     instance = new window.bootstrap.Offcanvas(el, { backdrop: true });
//                 }
//
//                 instance.show();
//             }
//         }, 150);
//     };
//
//     return (
//         <AuthContext.Provider
//             value={{
//                 user,
//                 token,
//                 login,
//                 logout,
//                 isAuthenticated: !!token,
//                 isAdmin: user?.role === "ADMIN",
//                 loading,
//                 openLoginModal,
//             }}
//         >
//             {children}
//         </AuthContext.Provider>
//     );
// };
//
// export const useAuth = () => useContext(AuthContext);
import React, {createContext, useContext, useEffect, useState} from "react";
import {jwtDecode} from "jwt-decode";
import {useNavigate, useLocation} from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    // 📌 UYGULAMA AÇILIŞINDA USER SET ET
    useEffect(() => {
        const t = localStorage.getItem("token");
        const u = localStorage.getItem("user");

        if (t && u) {
            try {
                jwtDecode(t); // token kontrol
                setUser(JSON.parse(u));
                setToken(t);
            } catch {
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                localStorage.removeItem("user");
            }
        }
        setLoading(false);
    }, []);

    // 🔁 REFRESH TOKEN KONTROL (route değişince)
    useEffect(() => {
        const refresh = localStorage.getItem("refreshToken");
        if (!refresh) return;

        try {
            const decoded = jwtDecode(refresh);
            if (decoded.exp * 1000 < Date.now()) {
                logout("Session expired. Please login again!");
            }
        } catch {
            logout("Session invalid. Please login again!");
        }
    }, [location.pathname]);

    // 🔥 LOGIN — CART MERGE + DOĞRU SAYFAYA YÖNLENDİRME
    const login = (u, access, refresh, cartGuidFromServer) => {
        localStorage.setItem("user", JSON.stringify(u));
        localStorage.setItem("token", access);
        localStorage.setItem("refreshToken", refresh);

        if (cartGuidFromServer) {
            localStorage.setItem("cart_guid", cartGuidFromServer);
        }

        setUser(u);
        setToken(access);

        // 🛒 CART MERGE → YENİ SEPETİ ÇEK
        setTimeout(() => {
            const cartCtx = window.APP_CART_CONTEXT;
            cartCtx?.reloadCart();
        }, 100);

        // ❗ Checkout sırasında login olduysa tekrar checkout'a dön
        // if (location.state?.fromCheckout) {
        //     navigate("/checkout", {replace: true});
        //     return;
        // }
        //
        // navigate("/", {replace: true});
    };

    // 🚪 LOGOUT — CART GUID YENİLE + SEPETİ SIFIRLA
    const logout = (msg = null) => {
        if (msg) localStorage.setItem("logoutMessage", msg);

        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        localStorage.removeItem("cart_guid");

        const newGuid = crypto.randomUUID();
        localStorage.setItem("cart_guid", newGuid);

        setUser(null);
        setToken(null);

        // UI sepet temizle
        requestAnimationFrame(() => {
            window.APP_CART_CONTEXT?.setCartProducts([]);
        });

        navigate("/", {replace: true});
    };

    // 🪟 LOGIN MODAL AÇICI
    const openLoginModal = () => {
        setTimeout(() => {
            const el = document.getElementById("login");
            if (el && window.bootstrap?.Offcanvas) {
                const instance =
                    window.bootstrap.Offcanvas.getInstance(el) ||
                    new window.bootstrap.Offcanvas(el);
                instance.show();
            }
        }, 200);
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                token,
                login,
                logout,
                isAuthenticated: !!token,
                isAdmin: user?.role === "ADMIN",
                loading,
                openLoginModal,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
